<template>
  <div>
    <h1 class="text-2xl font-bold text-gray-900 mb-6">个人中心</h1>
    
    <div class="bg-white p-6 rounded-lg shadow-md mb-8">
      <h2 class="text-xl font-semibold text-gray-800 mb-4">账号信息</h2>
      
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <p class="text-sm text-gray-500">用户名</p>
          <p class="text-lg text-gray-900">{{ authStore.user?.username }}</p>
        </div>
      </div>
    </div>
    
    <div class="bg-white p-6 rounded-lg shadow-md">
      <div class="flex justify-between items-center mb-4">
        <h2 class="text-xl font-semibold text-gray-800">转换历史</h2>
        
        <button 
          @click="loadHistory"
          class="text-blue-600 hover:text-blue-800 flex items-center"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          刷新
        </button>
      </div>
      
      <div v-if="conversionStore.loading" class="flex justify-center py-8">
        <svg class="animate-spin h-8 w-8 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      </div>
      
      <div v-else-if="conversionStore.history.length === 0" class="text-center py-8 text-gray-500">
        <p>暂无转换记录</p>
      </div>
      
      <div v-else>
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">原文件名</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">状态</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">创建时间</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">完成时间</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">操作</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="task in conversionStore.history" :key="task.id">
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ task.source_file_name }}</td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span 
                    class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                    :class="{
                      'bg-green-100 text-green-800': task.status === 'completed',
                      'bg-yellow-100 text-yellow-800': task.status === 'pending' || task.status === 'processing',
                      'bg-red-100 text-red-800': task.status === 'failed'
                    }"
                  >
                    {{ getStatusText(task.status) }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ formatDate(task.created_at) }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ task.completed_at ? formatDate(task.completed_at) : '-' }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm">
                  <span v-if="task.status === 'completed'">
                  <a 
                    :href="`https://pdf2doc.toolhero.top/api/download/${task.id}`" 
                    target="_blank"
                    class="text-blue-600 hover:text-blue-900"
                  >
                    下载
                  </a>
                  &nbsp;
                  <a 
                    @click="remove(task.id)"
                    class="text-blue-600 hover:text-blue-900"
                  >
                    删除
                  </a>
                </span>
                  <span v-else>-</span>
                </td>

                
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useAuthStore } from '../stores/auth';
import { useConversionStore } from '../stores/conversion';

const authStore = useAuthStore();
const conversionStore = useConversionStore();

onMounted(() => {
  loadHistory();
});

const loadHistory = () => {
  conversionStore.getUserHistory();
};

const remove =(id) =>{
  conversionStore.remove(id);

}

const getStatusText = (status) => {
  const statusMap = {
    'pending': '等待中',
    'processing': '处理中',
    'completed': '已完成',
    'failed': '失败'
  };
  
  return statusMap[status] || status;
};

const formatDate = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  return date.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
};
</script>